import React from 'react'

import { Shimmer } from '@wartek-id/shimmer'

type ModuleDetailsPlaceholderProps = {
  variant?: 'mobile' | 'desktop'
}

const ModuleDetailsPlaceholder = ({
  variant = 'mobile',
}: ModuleDetailsPlaceholderProps) => {
  if (variant === 'desktop') {
    return (
      <div role="alert" aria-busy="true" className="space-y-5">
        <section
          data-testid="module-placeholder-header"
          className="rounded-lg border border-gray-20 bg-white p-6"
        >
          <Shimmer width={80} height={12} className="mb-3" />
          <Shimmer width={280} height={20} className="mb-4" />
          <div className="mb-4 flex items-center">
            <Shimmer width={24} height={24} rounded />
            <Shimmer width={200} height={8} className="ml-3" />
          </div>
          <Shimmer width={160} height={32} />
        </section>

        <section className="rounded-lg border border-gray-20 bg-white p-6">
          {[0, 1, 2].map((_, idx) => (
            <div
              key={idx}
              className="mb-3 flex w-full rounded border border-subdued bg-white p-4 last:mb-0"
            >
              <Shimmer width={40} height={40} rounded />
              <div className="ml-3">
                <Shimmer width={160} height={12} className="mb-3" />
                <Shimmer width={240} height={8} noOfLines={2} />
              </div>
            </div>
          ))}
        </section>
      </div>
    )
  }

  return (
    <>
      <div
        role="alert"
        aria-busy="true"
        data-testid="module-placeholder-header"
        className="px-4 min-h-[160px] bg-expressive-dark-blue"
      >
        <div className="mb-1">
          <Shimmer width={280} height={12} className="mb-2" />
        </div>
        <div className="mb-2">
          <Shimmer width={280} height={12} className="mb-3" />
        </div>
        <div className="flex items-center mb-8">
          <Shimmer width={24} height={24} rounded />
          <div className="ml-2">
            <Shimmer width={280} height={8} />
          </div>
        </div>
        <div>
          <Shimmer width={280} height={12} noOfLines={2} className="mb-2" />
        </div>
      </div>
      <div className="px-4 py-10">
        {[0, 1, 2].map((_, idx) => (
          <div
            key={idx}
            className="flex relative p-4 w-full mx-auto mb-3 bg-white rounded border border-subdued"
          >
            <Shimmer width={64} height={64} rounded />
            <div className="ml-3">
              <Shimmer width={100} height={12} className="mb-4" />
              <Shimmer width={200} height={12} noOfLines={2} className="mb-1" />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default ModuleDetailsPlaceholder
